<template>
  <div
    class="relative min-h-screen flex items-center justify-center px-4 overflow-hidden bg-white"
  >
    <!-- ✨ Multi-Color Sparkle Background -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      
    </div>

    <!-- Login Card -->
    <div
      class="max-w-5xl w-full bg-white/90 shadow-2xl rounded-2xl grid grid-cols-1 md:grid-cols-2 overflow-hidden
             animate-slideIn backdrop-blur-md border border-gray-100 relative z-10"
    >
      <!-- Left Section -->
     <div
  class="hidden md:flex flex-col justify-center items-center bg-gradient-to-br from-white-600 to-white-600 text-white p-10"
  style="
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to bottom right, #2563eb, #4f46e5);
    color: #fff;
    border-radius: 1rem;
  "
>
  <img
    src='/images/loginpage.png'
    alt='Welcome Back'
    style="
      width: 100%;
      max-width: 100%;
      height: auto;
      border-radius: 1rem;
      object-fit: contain;
    "
  />
</div>


      <!-- Right Section -->
      <div class="p-8 sm:p-12 flex flex-col justify-center bg-white/95 relative">

        <!-- 🌀 Loading Overlay -->
        <transition name="fade">
          <div
            v-if="isLoading"
            class="absolute inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center rounded-2xl z-20"
          >
            <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-600 border-solid"></div>
          </div>
        </transition>

        <!-- 🔔 Message Alert -->
        <transition name="fade">
          <div
            v-if="msgTxt"
            :class="[
              'mb-4 text-sm font-medium px-4 py-2 rounded-lg',
              msgType === 'success'
                ? 'bg-green-100 text-green-700'
                : msgType === 'danger'
                ? 'bg-red-100 text-red-700'
                : 'bg-gray-100 text-gray-700'
            ]"
          >
            {{ msgTxt }}
          </div>
        </transition>

        <!-- ✅ LOGIN FORM -->
        <div v-if="page_no === 1">
          <div class="mb-8 text-center md:text-left">
            <h1 class="text-3xl font-semibold text-gray-900">Sign In</h1>
            <p class="text-gray-500 text-sm mt-1">
              Access your account and manage your dashboard.
            </p>
          </div>

          <form @submit.prevent="handleSubmit" class="space-y-5">
            <div class="form-group">
              <input
                type="email"
                v-model="email"
                id="email"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="email" class="form-label">Email Address</label>
            </div>

            <div class="form-group">
              <input
                v-model="password"
                :type="input_type"
                id="password"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="password" class="form-label">Password</label>
            </div>

            <div class="flex items-center justify-between text-sm">
              <label class="flex items-center space-x-2">
                <input type="checkbox" class="accent-blue-600 rounded" id="remember" />
                <span class="text-gray-600">Remember me</span>
              </label>
              <a
                href="javascript:void(0)"
                @click="set_page(3)"
                class="text-blue-600 hover:underline"
                >Forgot password?</a
              >
            </div>

            <button
              type="submit"
              class="btn w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-all duration-300 flex justify-center items-center"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-right-to-bracket mr-2"></i>
              <span v-if="!isLoading">Sign In</span>
              <span v-else>Processing...</span>
            </button>
          </form>

          <div class="mt-8 text-center text-sm text-gray-600">
            Don’t have an account?
            <a
              href="javascript:void(0)"
              @click="set_page(2)"
              class="text-blue-600 font-medium hover:underline"
              >Create one</a
            >
          </div>

          <!-- Google Login Button -->
          <div class="mt-8">
            <p class="text-center text-gray-400 text-sm mb-4">or continue with</p>
            <button
              type="button"
              @click="loginWithG()"
              class="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 hover:border-gray-400
                     text-gray-700 font-medium py-2.5 rounded-lg shadow-sm hover:shadow transition-all duration-300"
            >
              <img
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="Google"
                class="w-5 h-5"
              />
              Sign in with Google
            </button>
          </div>
        </div>

        <!-- ✅ SIGNUP FORM -->
        <div v-else-if="page_no === 2">
          <div class="mb-8 text-center md:text-left">
            <h1 class="text-3xl font-semibold text-gray-900">Create Account</h1>
            <p class="text-gray-500 text-sm mt-1">
              Fill in your details to create an account.
            </p>
          </div>

          <form @submit.prevent="handleSubmit1" class="space-y-5">
            <div class="form-group">
              <input
                type="text"
                v-model="name1"
                id="name1"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="name1" class="form-label">Full Name</label>
            </div>

            <div class="form-group">
              <input
                type="email"
                v-model="email1"
                id="email1"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="email1" class="form-label">Email Address</label>
            </div>

            <div class="form-group">
              <input
                type="password"
                v-model="password1"
                id="password1"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="password1" class="form-label">Password</label>
            </div>

            <button
              type="submit"
              class="btn w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-all duration-300"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-user-plus mr-2"></i>
              <span v-if="!isLoading">Sign Up</span>
              <span v-else>Processing...</span>
            </button>
          </form>

          <div class="mt-6 text-center text-sm text-gray-600">
            Already have an account?
            <a
              href="javascript:void(0)"
              @click="set_page(1)"
              class="text-blue-600 font-medium hover:underline"
              >Sign In</a
            >
          </div>
        </div>

        <!-- ✅ FORGOT PASSWORD -->
        <div v-else-if="page_no === 3">
          <div class="mb-8 text-center md:text-left">
            <h1 class="text-3xl font-semibold text-gray-900">Forgot Password</h1>
            <p class="text-gray-500 text-sm mt-1">
              Enter your registered email address to reset your password.
            </p>
          </div>

          <form @submit.prevent="handleSubmit2" class="space-y-5">
            <div class="form-group">
              <input
                type="email"
                v-model="email2"
                id="email2"
                class="form-control"
                placeholder=" "
                required
              />
              <label for="email2" class="form-label">Email Address</label>
            </div>

            <button
              type="submit"
              class="btn w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-all duration-300"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-envelope mr-2"></i>
              <span v-if="!isLoading">Send Reset Link</span>
              <span v-else>Processing...</span>
            </button>
          </form>

          <div class="mt-6 text-center text-sm text-gray-600">
            Remember your password?
            <a
              href="javascript:void(0)"
              @click="set_page(1)"
              class="text-blue-600 font-medium hover:underline"
              >Back to Sign In</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mainBaseUrl, apiBaseUrl } from '@/apis/appconst';
import { frogotUser, loginUser, regUser } from '@/apis/webapis';


export default {
  name: 'AppLogin',
  data() {
    return {
      base_url: "",
      api_base_url: apiBaseUrl,
      l1: ["1", "2", "3", "4", "5"],
      page_no: 1,
      viewPass: 0,
      email: "",
      password: "",
      name1: "",
      email1: "",
      email2: "",
      password1: "",
      input_type: "password",
      msgType: "",
      msgTxt: "",
      isLoading: false,
    };
  },
  methods: {
    set_page($pno) {
      this.page_no = $pno;
      this.msgType = "";
      this.msgTxt = "";
    },
    set_pass($pno) {
      this.viewPass = $pno;
      this.input_type = this.viewPass == 1 ? "text" : "password";
    },
    valField1(field, msg) {
      if (field && field.length > 0) {
        return true;
      } else {
        this.msgType = "danger";
        this.msgTxt = msg;
        return false;
      }
    },

    // ✅ LOGIN API
    async handleSubmit() {
      if (
        this.valField1(this.email, "Enter Email Address") &&
        this.valField1(this.password, "Enter Password")
      ) {
        this.msgType = "";
        this.msgTxt = "";
        this.isLoading = true; // Start loading

        try {
          const response = await loginUser(this.email, this.password);

          if (response.status) {
            sessionStorage.setItem("ldata", JSON.stringify(response.user_dt));
            this.msgType = "success";
            this.msgTxt = "Sign-in successful! Redirecting...";
            setTimeout(() => (window.location.href = "/"), 1500);
          } else {
            this.msgType = "danger";
            this.msgTxt = response.message || "Invalid credentials.";
          }
        } catch (err) {
          console.error(err);
          this.msgType = "danger";
          this.msgTxt = "Something went wrong. Please try again.";
        } finally {
          this.isLoading = false; // Stop loading
        }
      }
    },
    loginWithG(){
      window.location.href = this.api_base_url+"google_login";
    }
    ,  
    // ✅ REGISTER API
    async handleSubmit1() {
      if (
        this.valField1(this.name1, "Enter Name") &&
        this.valField1(this.email1, "Enter Email Address") &&
        this.valField1(this.password1, "Enter Password")
      ) {
        this.msgType = "";
        this.msgTxt = "";
        this.isLoading = true;

        try {
          const response = await regUser(this.name1, this.email1, "", this.password1);

          if (response.status) {
            this.msgType = "success";
            this.msgTxt = response.message || "Account created successfully!";
            setTimeout(() => this.set_page(1), 1500);
          } else {
            this.msgType = "danger";
            this.msgTxt = response.message || "Registration failed.";
          }
        } catch (err) {
          console.error(err);
          this.msgType = "danger";
          this.msgTxt = "Unable to register. Please try again later.";
        } finally {
          this.isLoading = false;
        }
      }
    },

    // ✅ FORGOT PASSWORD API
    async handleSubmit2() {
      if (this.valField1(this.email2, "Enter Email Address")) {
        this.msgType = "";
        this.msgTxt = "";
        this.isLoading = true;

        try {
          const response = await frogotUser(this.email2);

          if (response.status) {
            this.msgType = "success";
            this.msgTxt = response.message || "Password reset link sent!";
            setTimeout(() => this.set_page(1), 1500);
          } else {
            this.msgType = "danger";
            this.msgTxt = response.message || "Email not found.";
          }
        } catch (err) {
          console.error(err);
          this.msgType = "danger";
          this.msgTxt = "Unable to process your request. Please try again.";
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
  mounted() {
    this.base_url = mainBaseUrl;
      
    if ((window.location.href + "").includes("udata")) {
      const udata = this.$route.query.udata;
      const ldata = atob(udata);
      if (ldata.length > 0) {
        sessionStorage.setItem("ldata", ldata);
        window.location.href = "/";
      }
    }
  },
};
</script>


<style>
body {
  font-family: "Inter", sans-serif;
}

/* Floating Labels */
.form-group {
  position: relative;
  margin-bottom: 1.5rem;
}
.form-control {
  width: 100%;
  padding: 1rem 0.75rem 0.25rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: transparent;
  transition: all 0.25s ease;
}
.form-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.form-label {
  position: absolute;
  top: 1rem;
  left: 0.75rem;
  color: #9ca3af;
  font-size: 0.95rem;
  pointer-events: none;
  transition: all 0.25s ease;
}
.form-control:focus + .form-label,
.form-control:not(:placeholder-shown) + .form-label {
  top: 0.25rem;
  left: 0.65rem;
  font-size: 0.75rem;
  color: #3b82f6;
}

/* Slide Animation */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slideIn {
  animation: slideIn 0.7s ease forwards;
}
</style>
